/**
 * アプリケーションURL設定
 * .envに含める必要のない非機密URL設定を含む
 */

// APIエンドポイント
export const API_URLS = {
  // ベースAPIのURL - 環境変数から取得
  BASE_API: import.meta.env.VITE_HUMHUB_API_URL,

  // WhaleのURL
  WHALE: `${import.meta.env.VITE_WHALE_URL}`,

  // 各種エンドポイント
  AUTH: "/auth",
  CALENDAR: "/calendar",
  CHAT: "/mail",
  FILE: "/file",
  C_FILES: "/cfiles",
  POST: "/post",
  COMMENT: "/comment",
  LINK_LIST: "/linklist",
  STUDY_GROUP: "/space",
  REACTION: "/reaction",
  CONTENT: "/content",
  READ_LATER: "/readlater",
  READ_LATER_POSTS: "/readlater-posts",
  TAG: "/tag",
  TOPIC: "/topic",
  SYSTEM: "/system",
  ACTIVITIES: "/activity",

  // 認証関連
  OAUTH_LOGOUT: `${import.meta.env.VITE_OIDC_AUTHORITY}/api/v1/auth/oauth_logouts`,
  HUMHUB_OAUTH_LOGIN: "/auth/oidc-login",
};

// パス
export const PAGE_PATHS = {
  // テストログイン（開発環境のみ）
  TEST_LOGIN: "/test-login",
  // OIDC認証コールバック
  CALLBACK: "/callback",
  // フロントチャネルログアウト
  LOGOUT: "/logout",
  // 外部向けイベントページ
  PUBLIC_EVENT: "/public-event",
  // Not Foundページ
  NOT_FOUND: "/not-found",
};
